import { CallDataType } from 'types/call.type';
import axiosInstance from './config/api';
import { SortDirection, SortField } from 'types/call.type';

export const ManualCallbacks = {
    NOT_NEEDED: 'not_needed',
    NEEDED: 'needed',
    NULL: null,
} as const;

export type ManualCallbacksType = (typeof ManualCallbacks)[keyof typeof ManualCallbacks];
// { id: string; startDate: Date; endDate: Date; callStatus: string; partyStage: string; callDirection: string; search: string; perPage: number; sortOrder: SortDirection; sortBy: SortField; currentPage: number; }
export type CallsDataParams = {
    perPage?: number;
    currentPage?: number;
    manualCallback?: ManualCallbacksType;
    id?: string;
    sortOrder?: SortDirection;
    sortBy?: SortField;
    search?: string;
    callStatus?: string;
    partyStage?: string;
    callDirection?: string;
    disposition?: string;
    startDate?: Date;
    endDate?: Date;
    overDue?: boolean;
};

export type CallsDataType = {
    data: CallDataType[];
    pagination: {
        totalPages: number;
        totalRecords: number;
        currentPage: number;
        perPage: number;
    };
};

export const getCallsData = async ({ id, ...rest }: CallsDataParams) => {
    const params = {
        ...rest,
        workflowId: id,
    };
    return await axiosInstance.get<CallsDataType>('/calls', { params }).then((res) => res.data);
};
